package nacholab.supplies.pages.authentication

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import nacholab.supplies.MainViewModel
import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.Anchor
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import nacholab.supplies.components.NLButton
import nacholab.supplies.components.NLButtonLoading
import nacholab.supplies.components.NLTextInput
import nacholab.supplies.i18n.i18n
import nacholab.supplies.ui.theme.CommonStyles
import nacholab.supplies.ui.theme.SuppliesTheme
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.TextInput

@Composable
fun CodeVerificationScreen(mainViewModel: MainViewModel){
    val state by mainViewModel.state

    var code by remember { mutableStateOf("") }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(SuppliesTheme.colors.background)
            .padding(
                top = 24.px,
                leftRight = 10f.percent,
                bottom = 24.px
            )
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            Row(
                verticalAlignment = Alignment.CenterVertically
            ){
                Image(
                    src = "/ic_title.png",
                    modifier = Modifier.size(48.px)
                )
                Box(modifier = Modifier.size(12.px))
                SpanText(
                    text = "appTitle".i18n(state.lang),
                    modifier = Modifier
                        .fontSize(30.px)
                        .color(SuppliesTheme.colors.primary)
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth().weight(1f),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ){
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxWidth()
                ){
                    Anchor("https://play.google.com/store/apps/details?id=nacholab.soundboard") {
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                            modifier = Modifier
                                .background(SuppliesTheme.colors.utilityBlack)
                                .clip(Rect(cornerRadius = 18.px))
                                .padding(
                                    topBottom = 12.px,
                                    leftRight = 48.px
                                )
                                .onClick { }
                                .then(CommonStyles.hoverPointer.toModifier())
                        ) {
                            SpanText(
                                text = "authenticate_gplay_getinon".i18n(state.lang),
                                modifier = Modifier
                                    .fontSize(20.px)
                                    .color(SuppliesTheme.colors.primary)
                            )

                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(12.px)
                            ) {
                                Image(
                                    src = "/ic_google_play.webp",
                                    modifier = Modifier.width(56.px)
                                )
                                SpanText(
                                    text = "authenticate_gplay_gplay".i18n(state.lang),
                                    modifier = Modifier
                                        .fontSize(30.px)
                                        .color(SuppliesTheme.colors.primary)
                                )
                            }
                        }
                    }
                }
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxWidth()
                ) {
                    if (state.suppliesLoadingError!=null){
                        SpanText(
                            text = state.suppliesLoadingError?:"",
                            modifier = Modifier
                                .fontSize(20.px)
                                .textAlign(TextAlign.Center)
                                .color(SuppliesTheme.colors.utilityError)
                        )

                        Box(Modifier.size(24.px))
                    }

                    SpanText(
                        text = "verifycode_instructions".i18n(state.lang),
                        modifier = Modifier
                            .fontSize(20.px)
                            .textAlign(TextAlign.Center)
                            .color(SuppliesTheme.colors.primary)
                    )

                    Box(Modifier.size(24.px))

                    NLTextInput(
                        value = code,
                        onChange = { code = it },
                        placeholder = "ZUROPA",
                        modifier = Modifier
                            .fillMaxWidth(80f.percent)
                            .textAlign(TextAlign.Center)
                    )

                    Box(Modifier.size(24.px))

                    if (state.isAuthenticationLoading){
                        NLButtonLoading(modifier = Modifier.fillMaxWidth(80f.percent))
                    }else {
                        NLButton(
                            text = "authenticate_enter".i18n(state.lang),
                            modifier = Modifier.fillMaxWidth(80f.percent),
                            onClick = { mainViewModel.verifyCode(code) }
                        )
                    }
                }
            }
        }
    }
}